<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="paymentRecord_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="paymentRecord_orderShareBatch_button"
          @click="batchOrderShareApply"
        >
          批量分账
        </el-button>
        <el-button
          v-if="getLimit('paymentRecord_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      show-footer
      :footer-method="footerMethod"
      align="center"
      :checkbox-config="{ labelField: 'name', checkMethod: checkMethod2 }"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择机构"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="支付流水号"
          min-width="264"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入支付流水号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="orderCreateName"
          title="下单客户"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCreateName"
            placeholder="请输入下单客户"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="orderCreateName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCreateName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择托运人类型"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCreatePhone"
          title="托运人手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCreatePhone"
            placeholder="请输入托运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailCreateName"
          title="承运商"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailCreateName"
            placeholder="请输入承运商"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailDriverName"
          title="承运人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailDriverName"
            placeholder="请输入承运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementType"
          title="结算类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'settlementType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.settlementType"
            placeholder="请选择结算类型"
            clearable
          >
            <el-option
              v-for="item in parentData.settlementTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额（元）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="请输入下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="请输入上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCreateName"
          title="付款人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCreateName"
            placeholder="请输入付款人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailCreateName"
          title="收款人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailCreateName"
            placeholder="请输入收款人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="支付方式"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payTypes" placeholder="请选择支付方式">
            <el-option
              v-for="item in parentData.payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isPayAdvance"
          title="付款类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isPayAdvance')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isPayAdvance"
            placeholder="请选择付款类型"
            clearable
          >
            <el-option
              v-for="item in parentData.isPayAdvanceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderShareStatus"
          title="分账状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'orderShareStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.orderShareStatus"
            placeholder="请选择分账状态"
            clearable
          >
            <el-option
              v-for="item in parentData.orderShareStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mybankElectronicReceipt"
          title="电子回单"
          min-width="140"
          :formatter="
            ({ cellValue }) =>
              formatterField({ cellValue }, 'mybankElectronicReceipt')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.mybankElectronicReceipt"
            placeholder="请选择电子回单"
            clearable
          >
            <el-option
              v-for="item in parentData.mybankElectronicReceiptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              paymentRecord_rePayment_button &&
                scope.row.mybankPayStatus == 'FAIL'
            "
            class="item"
            effect="dark"
            content="重新支付"
            placement="top"
          >
            <vxe-button type="text" @click="rePay(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              paymentRecord_applyElectronicReceipt_button &&
                scope.row.mybankElectronicReceipt == 0
            "
            class="item"
            effect="dark"
            content="申请回单"
            placement="top"
          >
            <vxe-button type="text" @click="applyElectronicReceipt(scope.row)">
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              paymentRecord_orderShareApply_button &&
                scope.row.mybankPayStatus == 'SUCCESS' &&
                scope.row.orderShareStatus != 'FAIL'
            "
            class="item"
            effect="dark"
            content="申请分账"
            placement="top"
          >
            <vxe-button type="text" @click="orderShareApplyFunc(scope.row)">
              <i class="el-icon-edit-outline" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              paymentRecord_reOrderShareApply_button &&
                scope.row.mybankPayStatus == 'SUCCESS' &&
                scope.row.orderShareStatus == 'FAIL'
            "
            class="item"
            effect="dark"
            content="重新分账"
            placement="top"
          >
            <vxe-button type="text" @click="orderShareApplyFunc(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              paymentRecord_payQuery_button &&
                scope.row.mybankPayStatus == 'DEALING'
            "
            class="item"
            effect="dark"
            content="更新支付结果"
            placement="top"
          >
            <vxe-button type="text" @click="payQuery(scope.row)">
              <i class="el-icon-c-scale-to-original" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              paymentRecord_orderShareQuery_button &&
                scope.row.orderShareStatus == 'DEALING'
            "
            class="item"
            effect="dark"
            content="更新分账结果"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="orderShareQueryFunc(scope.row.mybankOrderNo)"
            >
              <i class="el-icon-c-scale-to-original" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="ModelCashMoney"
      title="重新支付"
      width="530"
      height="300"
      resize
    >
      <CashMoney ref="CashMoneyRef" @hideModel="hideModel" />
    </vxe-modal>
    <el-dialog
      :visible.sync="showElectronicReceiptFlag"
      :modal="false"
      width="600px"
      height="600px"
    >
      <img width="100%" :src="showElectronicReceiptUrl" />
    </el-dialog>
    <!-- 错误信息 -->
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { remitDefinite } from "@/api/transport";
import {
  balancePayQuery,
  mybankElectronicReceipt,
  obtainPrepayPushAgain,
  obtainPrepayPushOneQuery,
  orderShareApply,
  orderShareQuery
} from "@/api/InternetBanking";
import CashMoney from "../balancePayment/components/cashMoney";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "PaymentRecordList",
  components: {
    CashMoney
  },
  data() {
    return {
      exportObj: {
        exportUrl: "ntocc-tms-api/remitDefinite/exportPaymentRecord", //导出接口
        name: "财务分账"
      },
      callbackTimeRange: "",
      loading: false,
      tableData: [],
      dialogTableVisible: false,
      ModelCashMoney: false,
      showElectronicReceiptFlag: false,
      paymentRecord_search_button: false, //查询
      paymentRecord_orderShareBatch_button: false, //批量分账
      paymentRecord_rePayment_button: false, //重新支付
      paymentRecord_applyElectronicReceipt_button: false, //申请回单
      paymentRecord_orderShareApply_button: false, //申请分账
      paymentRecord_reOrderShareApply_button: false, //重新分账
      paymentRecord_payQuery_button: false, //更新支付结果
      paymentRecord_orderShareQuery_button: false, //更新分账结果
      showElectronicReceiptUrl: "",
      errorData: [],
      parentData: {},
      listQuery: {
        payerRoles: "0,3",
        payTypes: "4,5,6,9",
        pageNum: 1,
        notIsPayAdvance: 2,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.parentData.settlementTypeOptions = [
      { label: "次结", value: "0" },
      { label: "月结", value: "1" }
    ];
    this.parentData.isPayAdvanceOptions = [
      { label: "打款", value: "0" },
      { label: "预付", value: "1" }
    ];
    this.parentData.orderShareStatusOptions = [
      { label: "处理中", value: "DEALING" },
      { label: "成功", value: "SUCCESS" },
      { label: "未分账", value: "NOTAPPLIED" },
      { label: "失败", value: "FAIL" }
    ];
    this.parentData.mybankElectronicReceiptOptions = [
      { label: "可申请", value: "0" },
      { label: "已申请", value: "1" }
    ];
    this.parentData.payTypeOptions = [
      // {label: '油点', value: '1'},
      // {label: '加油', value: '2'},
      // {label: '转账支付', value: '3'},
      { label: "余额支付", value: "4" },
      { label: "合并打款", value: "5" },
      { label: "车队分账", value: "6" },
      { label: "凭证支付", value: "9" },
      { label: "全部", value: "4,5,6,9" }
      // { label: '银行支付', value: '10' },
    ];
    this.paymentRecord_search_button = getLimit("paymentRecord_search_button");
    this.paymentRecord_orderShareBatch_button = getLimit(
      "paymentRecord_orderShareBatch_button"
    );
    this.paymentRecord_rePayment_button = getLimit(
      "paymentRecord_rePayment_button"
    );
    this.paymentRecord_applyElectronicReceipt_button = getLimit(
      "paymentRecord_applyElectronicReceipt_button"
    );
    this.paymentRecord_orderShareApply_button = getLimit(
      "paymentRecord_orderShareApply_button"
    );
    this.paymentRecord_reOrderShareApply_button = getLimit(
      "paymentRecord_reOrderShareApply_button"
    );
    this.paymentRecord_payQuery_button = getLimit(
      "paymentRecord_payQuery_button"
    );
    this.paymentRecord_orderShareQuery_button = getLimit(
      "paymentRecord_orderShareQuery_button"
    );
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        remitDefinite(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    //重新申请电子回单
    applyElectronicReceipt(row) {
      const rLoading = this.openLoading();
      mybankElectronicReceipt(
        {
          branchCode: row.branchCode,
          orderNo: row.mybankOrderNo,
          merchantId: row.mybankPayerId
        },
        "post"
      ).then(response => {
        rLoading.close();
        let type = response.status === 0 ? "success" : "error";
        this.findList();
        this.$message({
          message: response.msg,
          type: type
        });
      });
    },
    rePay(c) {
      let rePayInfo = { orderNo: c.mybankOrderNo, totalAmount: c.amount };
      if (c.payType === 4) {
        this.$refs.CashMoneyRef.getInfo(rePayInfo);
        this.ModelCashMoney = true;
      } else if (c.payType === 5) {
        this.$confirm("是否重新支付?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const rLoading = this.openLoading();
            obtainPrepayPushAgain(rePayInfo.orderNo).then(response => {
              rLoading.close();
              this.findList();
              this.$message({
                message: response.msg,
                type: "success"
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      }
    },
    payQuery(c) {
      if (c.payType === 4 || c.payType === 6) {
        let rLoading = this.openLoading();
        balancePayQuery(c.mybankOrderNo).then(response => {
          rLoading.close();
          if (response.status === 500) {
            this.dialogTableVisible = true;
            this.errorData = response.data;
          } else {
            let type = response.status === 0 ? "success" : "error";
            this.$message({
              message: response.msg,
              type: type
            });
          }
          this.findList();
        });
      } else if (c.payType === 5) {
        let rLoading = this.openLoading();
        obtainPrepayPushOneQuery(c.mybankOrderNo).then(response => {
          rLoading.close();
          if (response.status === 500) {
            this.dialogTableVisible = true;
            this.errorData = response.data;
          } else {
            let type = response.status === 0 ? "success" : "error";
            this.$message({
              message: response.msg,
              type: type
            });
          }
          this.findList();
        });
      }
    },
    //查询网商分账结果
    orderShareQueryFunc(c) {
      const rLoading = this.openLoading();
      orderShareQuery(c).then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.$message({
            message: response.msg,
            type: type
          });
        }
        this.findList();
      });
    },
    getShareType(payType) {
      switch (payType) {
        case 4:
          return 0; //余额支付
        case 5:
          return 1; //合并支付
        case 6:
          return 2; //车队分账
      }
    },
    //分账
    orderShareApplyFunc(c) {
      this.accdata = [];
      this.accdata.push({
        relateOrderNo: c.mybankOrderNo,
        shareType: this.getShareType(c.payType)
      });
      this.$confirm("是否分账?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          orderShareApply(this.accdata).then(response => {
            rLoading.close();
            if (response.status === 500) {
              this.dialogTableVisible = true;
              this.errorData = response.data;
            } else {
              let type = response.status === 0 ? "success" : "error";
              this.$message({
                message: response.msg,
                type: type
              });
            }
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 批量分账
    batchOrderShareApply() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({
          message: "请选择需要分账的项",
          type: "warning"
        });
        return false;
      }
      if (checkedRowArray.length > 20) {
        this.$message({
          message: "批量处理最多20条数据",
          type: "warning"
        });
        return false;
      }
      const rLoading = this.openLoading();
      this.accdata = [];
      checkedRowArray.map(item => {
        this.accdata.push({
          relateOrderNo: item.mybankOrderNo,
          shareType: this.getShareType(item.payType)
        });
      });
      orderShareApply(this.accdata)
        .then(response => {
          if (response.status === 500) {
            this.dialogTableVisible = true;
            this.errorData = response.data;
          } else {
            let type = response.status === 0 ? "success" : "error";
            this.findList();
            this.$message({
              message: response.msg,
              type: type
            });
          }
        })
        .finally(f => {
          rLoading.close();
          this.findList();
        });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value == cellValue
      );
      return item ? item.label : "";
    },
    hideModel() {
      this.ModelCashMoney = false;
      this.findList();
    },
    checkMethod2({ row }) {
      return row.mybankPayStatus === "SUCCESS";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["amount"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
